import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const DetailsGrid = styled.div<{ marginTop?: string }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px 32px;
  ${(props) => props.marginTop && `margin-top: ${props.marginTop};`}
`;

export const NotesContainer = styled.div`
  grid-column: span 2;
`;

export const DetailLabel = styled.p`
  margin: 0 0 8px 0;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
`;

export const DetailValue = styled.p`
  margin: 0;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
`;

export const DividerContainer = styled.div`
  margin: 24px 0;
`;

export const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
